export const breakpoint = 550;